<template>
  <v-container fluid class="mb-10">
    <v-card elevation="0" color="transparent">
      <v-row justify="center">
        <v-col cols="12" sm="3">
          <v-card class="mx-auto" tile elevation="1" outlined>
            <v-list dense disabled>
              <v-list-item>
                <v-list-item-icon class="mr-3">
                  <v-icon>mdi-code-braces-box</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="mt-1"> I18n </v-list-item-title>
              </v-list-item>
              <v-list-group
                v-model="item"
                no-action
                value="true"
                append-icon=""
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon size="20" class="ml-3">
                        mdi-chevron-right
                      </v-icon>
                      Admin i18n
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-group>
            </v-list>
            <v-row dense no-gutters align="center">
              <v-col class="text-center">
                <v-btn
                  v-show="json"
                  outlined
                  class="mb-2"
                  color="success"
                  elevation="1"
                  :disabled="!change_something"
                  @click="done()"
                >
                  <v-icon class="mr-2"> mdi-check-outline </v-icon>
                  {{ $t("store.update") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col>
          <v-card :loading="loading" elevation="0" color="purple darken-4">
            <v-jsoneditor
              v-model="json"
              :plus="false"
              :options="options"
              height="710px"
              class="json-part pt-1"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "I18n",
  data() {
    return {
      loading: true,
      item: 1,
      change_something: false,
      json: {},
      temp: {},
      options: {
        enableTransform: true,
        modes: ["tree", "code", "text", "view"],
        onChange: this.change,
      },
    };
  },
  computed: {
    admin_i18n() {
      return this.$store.state.admin.admin_i18n;
    },
  },
  mounted() {
    this.json = this.admin_i18n;
    this.temp = this.admin_i18n;
    this.loading = false;
  },
  methods: {
    change() {
      this.change_something = true;
    },
    done() {
      console.log(this.json);
      if (JSON.stringify(this.json) !== JSON.stringify(this.temp)) {
        this.$store.dispatch("setLoader", {
          showing: true,
          text: "Saving json",
        });
        this.$store.dispatch("UPDATE_ADMIN_I18N", this.json).then((res) => {
          this.$store.dispatch("setLoader", {
            showing: false,
            text: "Saving json",
          });
          this.$store.dispatch("setSnackbar", {
            showing: true,
            text: "Change added",
            color: "success",
          });
        });
      } else {
        this.$store.dispatch("setSnackbar", {
          showing: true,
          text: "No Change Made",
          color: "warning",
        });
        this.change_something = false;
      }
    },
  },
};
</script>

<style>
.json-part {
  background: #fafafa;
}

.json-part .jsoneditor-menu {
  background: #7b1fa2 !important;
}
.json-part .jsoneditor-menu > button {
  opacity: 1;
}
.json-part .jsoneditor-frame {
  border-radius: 7px;
  border: 1px solid transparent;
  background-color: #fafafa;
  padding: 0 2px;
  margin: 0;
}
.json-part .jsoneditor {
  border-radius: 4px;
  border: 1px solid #7b1fa2;
}
.json-part .jsoneditor-contextmenu .jsoneditor-menu button {
  color: #fafafa;
}
.json-part .jsoneditor-contextmenu .jsoneditor-menu button:hover {
  color: black;
}
.json-part
  .jsoneditor-contextmenu
  .jsoneditor-menu
  li
  button.jsoneditor-selected,
.jsoneditor-contextmenu .jsoneditor-menu li button.jsoneditor-selected:focus,
.jsoneditor-contextmenu .jsoneditor-menu li button.jsoneditor-selected:hover {
  background: #7283b3;
}
.json-part .jsoneditor-menu a.jsoneditor-poweredBy {
  display: none;
}
</style>
